var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UsersNetworkModal',{attrs:{"is-loading":_vm.isLoading,"title":_vm.$t('title'),"btn-confirm-text":_vm.$t('btnConfirmText'),"translation":"2"},on:{"onConfirm":_vm.onClickConfirm},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }